'use es6';

import * as params from 'hub-http/helpers/params';
import { useMemo } from 'react';
export function useQueryParams() {
  const queryParams = useMemo(() => params.parse(window.location.search.substring(1)), []);
  return queryParams;
}